import { hooks } from '@wove/react';
import { cloneElement, Fragment, ReactElement, useState } from 'react';
import { ListItem, ListItemProps } from '../../../list/list-item';
import { FormTextColumnItem } from '../../types';
import './style.less';

export type FormTextProps = {
  className?: string;
  placeholder?: string;
  arrow?: ListItemProps['arrow'];
  children?: ReactElement;
};

type FormTextPropsInner = {
  value?: FormTextColumnItem;
  onChange: (value?: FormTextColumnItem) => void;
  disabled?: boolean;
  readOnly?: boolean;
  suffix?: JSX.Element | string;
} & FormTextProps;

/**
 * 自定义FormItem，可用于跳转页面取值交互
 * ```
 * 比普通自定义FormItem，多了一个clickTigger属性，用于触发click事件通知
 * ```
 */
export const FormText = (props: FormTextProps) => {
  const newProps = props as FormTextPropsInner;
  const [clickTigger, setClickTigger] = useState<number>();

  const onClick = hooks.useCallbackRef(() => {
    if (newProps.disabled || newProps.readOnly) return;
    setClickTigger(Date.now());
  });

  return (
    <ListItem
      arrow={newProps.arrow}
      prefix={!newProps.value ? props.placeholder : ''}
      className={props.className}
      onClick={onClick}
      extra={newProps.suffix}
    >
      <Fragment>
        {cloneElement(props.children as JSX.Element, {
          value: newProps.value,
          onChange: newProps.onChange,
          clickTigger,
        })}
      </Fragment>
    </ListItem>
  );
};

FormText['domTypeName'] = 'Text';
